import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/app/src/components/ui/copy-button.tsx");
